module.exports = __webpack_public_path__ + "static/media/Promotion_Card_TH_Small.0ec0a9d3.jpg";